// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;

/*
render function
*/
import { searchResultsListFunction } from 'js/searchResultsListService';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/searchResultsListService', () => import('js/searchResultsListService'));
registerDynImportEntry('js/desSearchService', () => import('js/desSearchService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
registerDynImportEntry('js/customCommandsService', () => import('js/customCommandsService'));
registerDynImportEntry('js/messagingService', () => import('js/messagingService'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "imports": [],
  "actions": {
    "render": {
      "method": "searchResultsListFunction",
      "deps": "js/searchResultsListService"
    },
    "searchChange": {
      "actionType": "batchJob",
      "steps": [{
        "action": "updateInputs"
      }, {
        "action": "updateOutputs"
      }, {
        "action": "searchResultsListDataProviderMethod"
      }, {
        "action": "onMountResultListFunction"
      }]
    },
    "updateInputs": {
      "actionType": "JSFunction",
      "method": "updateData",
      "inputData": {
        "data": "{{data}}",
        "dataProps": {
          "category": "{{data.eventData.category}}",
          "query": "{{data.eventData.query}}",
          "searchFilters": "{{data.eventData.searchFilters}}",
          "ownership": "{{data.eventData.ownership}}"
        }
      },
      "deps": "js/desSearchService"
    },
    "updateOutputs": {
      "actionType": "JSFunction",
      "method": "updateData",
      "inputData": {
        "data": "{{data}}",
        "dataProps": {
          "totalCount": 0,
          "facets": [],
          "searchObjects": null
        }
      },
      "deps": "js/desSearchService"
    },
    "onMountResultListFunction": {
      "actionType": "JSFunction",
      "method": "onMountResultListFunction",
      "deps": "js/searchResultsListService"
    },
    "searchResultsListDataProviderMethod": {
      "actionType": "dataProvider",
      "method": "searchResultsListDataProvider"
    },
    "loadData": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "query searchObjects( $projectId: String, $collaborationspaceId: String, $folderId: String, $skip: Int, $searchInput: Json, $sortParams: Json) { searchObjects( projectId: $projectId, collaborationspaceId: $collaborationspaceId, folderId: $folderId, skip: $skip, searchInput: $searchInput, sortParams: $sortParams ) { error facets items totalCount skip selectedFacets }}",
            "variables": {
              "collaborationspaceId": "{{props.collaborationspaceid}}",
              "projectId": "{{props.projectid}}",
              "searchInput": {
                "category": "{{data.category}}",
                "queryString": "{{data.query}}",
                "facets": "{{data.searchFilters}}",
                "removeFacets": "{{props.removefacets}}",
                "ownership": "{{data.ownership}}"
              },
              "sortParams": [{
                "fieldName": "name",
                "sortDirection": "ASC"
              }],
              "skip": "{{data.dataProviders.searchResultsListDataProvider.startIndex}}"
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{props.accsessionid}}"
      },
      "events": {
        "success": [{
          "name": "updateFacets",
          "eventData": {
            "facets": "{{data.facets}}",
            "selectedFacets": "{{data.selectedFacets}}",
            "query": "{{data.query}}"
          }
        }]
      },
      "dataParsers": [{
        "id": "searchObjects",
        "responseObjs": "data.data.searchObjects.items"
      }],
      "outputData": {
        "searchObjects": "data.data.searchObjects.items",
        "totalCount": "data.data.searchObjects.totalCount",
        "facets": "data.data.searchObjects.facets",
        "selectedFacets": "data.data.searchObjects.selectedFacets"
      },
      "actionMessages": {},
      "deps": "js/desSearchService"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    },
    "storeSelectedCustomCommandData": {
      "actionType": "JSFunction",
      "method": "storeSelectedObjectData",
      "inputData": {
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/customCommandsService"
    },
    "performBatchAction": {
      "actionType": "batchJob",
      "steps": [{
        "action": "publishToACCEventBus"
      }, {
        "action": "storeSelectedCustomCommandData"
      }]
    },
    "validateExtensionSrc": {
      "actionType": "JSFunction",
      "method": "validateExtensionSrc",
      "inputData": {
        "extensionssrc": "{{props.extensionssrc}}"
      },
      "deps": "js/customCommandsService"
    },
    "createChildCommandData": {
      "actionType": "JSFunction",
      "method": "createChildCommandData",
      "inputData": {
        "commands": "{{ctx.customCommadsValidData.commands}}"
      },
      "deps": "js/customCommandsService"
    },
    "invalidCustomCommandNotification": {
      "actionType": "JSFunction",
      "method": "invalidCustomCommandNotification",
      "inputData": {
        "errorData": "{{ctx.customCommadsErrors}}",
        "customCommandInput": "{{ctx.customCommadsInput}}",
        "vmo": "{{data}}"
      },
      "outputData": {
        "invalidCustomCommandError": "invalidCustomCommandError"
      },
      "actionMessages": {
        "success": [{
          "message": "invalidCustomCommandsErrorMsg"
        }]
      },
      "deps": "js/customCommandsService"
    },
    "publishSelectedCustomCommandData": {
      "actionType": "Event",
      "method": "Event",
      "inputData": {
        "events": [{
          "name": "publishSelectedCustomCommandData",
          "eventData": {
            "eventName": "{{parameters.eventId}}",
            "eventData": "{{ctx.selectedCustomCommandData}}"
          }
        }]
      }
    },
    "setTimeoutForWarning": {
      "actionType": "JSFunction",
      "method": "setTimeout",
      "inputData": {
        "type": "ERROR",
        "value": 5
      },
      "deps": "js/messagingService"
    }
  },
  "data": {
    "columnConfig": {},
    "query": "",
    "category": "",
    "facets": [],
    "searchFilters": [],
    "ownership": "anyOne"
  },
  "dataParseDefinitions": {
    "searchObjects": {
      "cellHeader1": "{{response.name}}",
      "cellHeader2": {
        "key": "{{i18n.project}}",
        "value": "{{response.project.name}}"
      },
      "cellHeader3": {
        "key": "{{i18n.location}}",
        "value": "{{response.folders[0].folderPath}}"
      },
      "identifier": "{{response.urn}}",
      "typeIconURL": "{{response.typeIconURL}}",
      "type": "{{response.type}}",
      "originalObj": "{{response}}"
    }
  },
  "dataProviders": {
    "searchResultsListDataProvider": {
      "action": "loadData",
      "response": "{{data.searchObjects}}",
      "totalFound": "{{data.totalCount}}",
      "selectionModelMode": "single",
      "inputData": {
        "selectionModel": "{{subPanelContext.selectionModel}}"
      },
      "commandsAnchor": "search_cell_commands"
    }
  },
  "i18n": {
    "actions": ["projectMessages"],
    "creationDate": ["projectMessages"],
    "description": ["projectMessages"],
    "lastModifiedBy": ["projectMessages"],
    "lastModifiedDate": ["projectMessages"],
    "location": ["projectMessages"],
    "name": ["projectMessages"],
    "owner": ["projectMessages"],
    "project": ["projectMessages"],
    "revId": ["projectMessages"],
    "showing": ["projectMessages"],
    "size": ["projectMessages"],
    "status": ["projectMessages"],
    "typeName": ["projectMessages"],
    "customCommandErrorMsg": ["projectMessages"]
  },
  "lifecycleHooks": {
    "render": "render",
    "onMount": "validateExtensionSrc"
  },
  "onEvent": [{
    "eventId": "searchResultsListDataProvider.selectionChangeEvent",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-search-results-as-list.selected",
      "eventData": "{{eventData.selectedObjects}}"
    }
  }, {
    "eventId": "des.object.open",
    "action": "performBatchAction",
    "inputArgs": {
      "eventId": "des-search-results-as-list-item.open",
      "eventData": "{{eventData.selectedObject}}"
    }
  }, {
    "eventId": "des.search.input.changed",
    "action": "searchChange",
    "cacheEventData": true
  }, {
    "eventId": "des-custom-commands.invalid",
    "action": "invalidCustomCommandNotification"
  }, {
    "eventId": "des-custom-commands.valid",
    "action": "createChildCommandData"
  }, {
    "eventId": "customCommandSelected",
    "action": "publishSelectedCustomCommandData",
    "inputArgs": {
      "eventId": "{{eventData.eventData}}"
    }
  }, {
    "eventId": "publishSelectedCustomCommandData",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "{{eventData.eventName}}",
      "eventData": "{{eventData.eventData}}"
    }
  }],
  "messages": {
    "invalidCustomCommandsErrorMsg": {
      "messageType": "ERROR",
      "messageText": "{{data.invalidCustomCommandError}}"
    }
  },
  "props": {
    "collaborationspaceid": {
      "type": "string"
    },
    "accsessionid": {
      "type": "string"
    },
    "projectid": {
      "type": "string"
    },
    "extensionssrc": {
      "type": "string"
    },
    "hide-commands": {
      "type": "string"
    },
    "remove-facets": {
      "type": "string"
    },
    "view-path": {
      "type": "object"
    },
    "view-id": {
      "type": "string"
    }
  },
  "conditions": {},
  "_viewModelId": "SearchResultsList",
  "_uniqueViewModelId": "SearchResultsList",
  "ctx": {
    "customCommadsValidData": {
      "type": "object"
    },
    "customCommadsErrors": {
      "type": "object"
    },
    "customCommadsInput": {
      "type": "object"
    },
    "selectedCustomCommandData": {
      "type": "object"
    }
  }
};

/*
define component
*/
const Component = createComponent(declViewModelJson, searchResultsListFunction, undefined, ctxImportObj);
export default Component;